import { BallBg } from 'components';
import React from 'react';
import { Banner } from 'screens/Website/Home/OurAthletes/components';
import { AthleteFocus, MeetOurTeam, Shoutout } from './components';

const OurStory = (props) => {
  return (
    <React.Fragment>
      <BallBg />
      <Banner />
      {/* <VideoBanner/> */}
      <MeetOurTeam />
      <AthleteFocus />
      <Shoutout />
    </React.Fragment>
  );
};

export default OurStory;
